<template>
  <div>
    The participant will be unenrolled from the study. Their data to this point will be preserved.
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,

    props: {
      id: String
    }
  };
</script>
